import { Toolbar, Typography } from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import "moment/locale/vi";
import PropTypes from "prop-types";
import PickerMonth from "../../../partials/pickerMonth";
import { parseCountry } from "../../../utils/setting";
// Style
import { toolbarStyles } from "./styles";

class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().format("MM/YYYY"),
    };
    this.handleChangeDate = this.handleChangeDate.bind(this);
  }
  handleChangeDate(date) {
    const _this = this;
    this.setState({ date: date }, function () {
      _this.props.fetchData(date);
    });
  }
  render() {
    const { classes, t } = this.props;
    const { i18n } = this.props;
    const lng = parseCountry(i18n.language);
    const { date } = this.state;
    return (
      <Toolbar className={classes.root}>
        <div className={classes.title}>
          <Typography
            color="inherit"
            variant="h6"
            className={classes.titleText}
          >
            {t("dashboard_reaction_toolbar_total_reaction")}
          </Typography>
        </div>
        <div className={classes.spacer}>
          <Typography color="inherit" variant="body1">
            {t("dashboard_reaction_toolbar_last_3_months_before")}
          </Typography>
        </div>
        <div className={classes.actions}>
          <div className={classes.search}>
            <PickerMonth
              handleChange={this.handleChangeDate}
              time={this.state.date}
            />
          </div>
        </div>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  userServicesDispatch: dispatch.userServices,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(toolbarStyles)(EnhancedTableToolbar)));
